var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-message"},[(_vm.$slots['my'])?_c('div',{staticClass:"message-contain message-contain--my"},[_vm._t("my")],2):_vm._e(),_c('el-avatar',{staticClass:"message-avatar",attrs:{"size":40,"src":_vm.avatar}}),(_vm.$slots['his'])?_c('div',{staticClass:"message-contain message-contain--his"},[_vm._t("his")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }